// Hensslers uses an app for mix and match, called: Bundly. But they wanted to have a lot of design changes.
// A lot was possible with CSS —> bundly.scss
// But some needed to be with JS and you’ll find the changes in this file.
// For some changes we needed some product data or text from the backend. See bundly-data.liquid and the updateBundlyData()
//
// The file starts at the bottom with an object observer. After the section changes we apply our changes
// Then we fetch the newest data (it changes when you go to the next page in the product grid)
// Then we do the styling
// - First the product cards (the price, the quantity selector)
// - Secondly the summery sections

//  the code at the end to open the cart drawer when atc clicked has been added later

// bundly adjustments
if (document.querySelector('.bundly__block')) {
  const bundlyBlock = document.querySelector('.bundly__block');
  function showToolTip(newInput) {
    const tooltip = newInput.querySelector('.bundly_tooltip');
    tooltip.removeAttribute('hidden');
    setTimeout(() => {
      tooltip.setAttribute('hidden', '');
    }, 2000);
  }

  let originalPriceNumber;
  let bundlyData;
  let currentPage;

  async function updateBundlyData() {
    try {
      let currentPage = document.querySelector('.page.current')?.innerText || 1;
      const bundlyDataUrl = `${bundlyBlock.dataset.url}/?page=${currentPage}&sections=bundly-data`;
      const response = await fetch(bundlyDataUrl);
      const data = await response.json();
      document.querySelector('#bundly-data').innerHTML = data['bundly-data'];
      bundlyData = JSON.parse(
        document.querySelector('#bundly-product-info').innerText,
      );
      updateLayout();
    } catch (error) {
      console.error('Error fetching Bundly data:', error);
    }
  }

  function updateLayout() {
    const bundlyGridItems = document.querySelectorAll(
      '.bundly__component_grid_item',
    );
    const isFull = !document
      .querySelector('.bundly__add_to_cart_button')
      .hasAttribute('disabled');
    const quantityButtonTemplate = document.querySelector(
      '#bundly-quantity-selector',
    ).innerHTML;

    bundlyGridItems.forEach((card) => {
      const button = card.querySelector('.bundly__add_to_bundle_button');
      if (
        button.querySelector('.bundly__product_in_bundle_count') &&
        !button.parentElement.querySelector('.bundly__quantity_select')
      ) {
        const variantId = button.dataset.variantId;
        const componentIndex = button.dataset.componentIndex;
        const newInput = document.createElement('div');

        newInput.innerHTML = quantityButtonTemplate;
        newInput.className = 'bundly__quantity_select';
        newInput.querySelector('.quantity__input').value =
          document.querySelectorAll(
            `.bundly__slot[data-variant-id="${variantId}"]`,
          ).length;

        newInput
          .querySelector('.quantity__button-minus')
          .addEventListener('click', () => {
            document
              .querySelector(
                `.bundly__slot[data-variant-id="${variantId}"] .bundly__slot_remove`,
              )
              .click();
          });

        if (isFull) {
          newInput
            .querySelector('.quantity__button-plus')
            .addEventListener('click', () => showToolTip(newInput));
        } else {
          newInput
            .querySelector('.quantity__button-plus')
            .addEventListener('click', () => button.click());
        }

        let value = '';
        newInput
          .querySelector('.quantity__input')
          .addEventListener('focus', (e) => {
            value = e.target.value;
          });

        newInput
          .querySelector('.quantity__input')
          .addEventListener('change', (e) => {
            const url = window.location.href;
            const freeSpots = document.querySelectorAll(
              '.bundly__slot_image:not(.bundly__slot_image--selected)',
            ).length;
            const selectedSlots = document.querySelectorAll(
              '.bundly__slot_image--selected',
            ).length;
            const selectedSlotsByVariant = Array.from(
              document.querySelectorAll(
                `.bundly__slot[data-variant-id="${variantId}"]`,
              ),
            );
            let difference =
              Number(e.target.value) - selectedSlotsByVariant.length;

            let urlParts = window.location.pathname.split('/');
            Bundly.urlStateBuilder.getPathname = function () {
              return urlParts.join('/');
            };

            if (difference > 0 && !isFull) {
              for (let i = 1; i <= freeSpots; i++) {
                if (i > difference) break;
                const componentVariantIndex = selectedSlots + i;

                const updatedUrlState =
                  Bundly.urlStateBuilder.withVariantSelection(
                    componentIndex,
                    componentVariantIndex,
                    variantId,
                  );
                const _previousUrlState = urlParts.pop();
                urlParts.push(updatedUrlState);
              }
              window.location.pathname = urlParts.join('/');
            } else if (difference < 0) {
              difference *= -1;
              for (let i = 1; i <= difference; i++) {
                const lastSelectedVariant = selectedSlotsByVariant.pop();
                const componentVariantIndex = lastSelectedVariant.querySelector(
                  '.bundly__slot_remove',
                ).dataset.componentVariantIndex;

                const updatedUrlState =
                  Bundly.urlStateBuilder.withVariantSelection(
                    componentIndex,
                    componentVariantIndex,
                    null,
                  );
                const _previousUrlState = urlParts.pop();
                urlParts.push(updatedUrlState);
              }
              window.location.pathname = urlParts.join('/');
            } else if (isFull) {
              e.target.value = value;
              showToolTip(newInput);
            }
          });

        button.parentNode.insertBefore(newInput, button);
      } else if (isFull && !button.hasAttribute('disabled')) {
        button.setAttribute('disabled', '');
      }

      let priceSection = card.querySelector('.bundly__component_prices');
      if (
        bundlyData &&
        bundlyData[button.dataset.variantId]?.compareAtPrice &&
        bundlyData[button.dataset.variantId]?.compareAtPrice !==
          bundlyData[button.dataset.variantId]?.price &&
        !priceSection.querySelector('.strikethrough-price')
      ) {
        const price = parseFloat(
          bundlyData[button.dataset.variantId].price.replace(',', '.'),
        );
        const compareAtPrice = parseFloat(
          bundlyData[button.dataset.variantId].compareAtPrice.replace(',', '.'),
        );
        priceSection.innerHTML =
          document.querySelector('#bundly_card-price').innerHTML;
        priceSection.querySelector('.discount-bubble').innerText =
          Math.round(((price - compareAtPrice) / compareAtPrice) * 100) + '%';
        priceSection.querySelector(
          '.bundly__component_original_price',
        ).innerText = bundlyData[button.dataset.variantId].price;
        priceSection.querySelector('.strikethrough-price').innerText =
          bundlyData[button.dataset.variantId].compareAtPrice;
        if (card.querySelector('.bundly__component_unit_price')) {
          const newElement = document.createElement('div');
          newElement.className = 'bundly_unit_price';
          newElement.innerText = card.querySelector(
            '.bundly__component_unit_price',
          ).innerText;
          card
            .querySelector('.bundly__component_prices')
            .appendChild(newElement);
        }
      } else if (
        card.querySelector('.bundly__component_unit_price') &&
        !card.querySelector('.bundly_unit_price')
      ) {
        const newElement = document.createElement('div');
        newElement.className = 'bundly_unit_price';
        newElement.innerText = card.querySelector(
          '.bundly__component_unit_price',
        ).innerText;
        card.querySelector('.bundly__component_prices').appendChild(newElement);
      }
    });

    updateSummary();
  }

  function updateSummary() {
    const textData = document.querySelector('#bundly_text-changes');
    const gridTitle = document.querySelector(
      '.bundly__component_header_title a',
    );
    const detailsTitle = document.querySelector(
      '.bundly__details_heading_title',
    );
    const slotTitle = document.querySelector('.bundly__slot_component_title');
    const slotHeading = document.querySelector(
      '.bundly__slot_component_heading',
    );
    const bundlySlots = document.querySelector('.bundly__slot_component');
    const slotTitleEmpty = document.querySelectorAll('.bundly__slot');

    if (
      !textData ||
      !gridTitle ||
      !detailsTitle ||
      !slotTitle ||
      !slotHeading ||
      !bundlySlots
    )
      return;

    const gridTitleText = textData.getAttribute(
      'bundly__component_header_title',
    );
    const detailsTitleText = textData.getAttribute(
      'bundly__details_heading_title',
    );
    const slotTitleText = textData.getAttribute('bundly__slot_component_title');
    const slotTitleEmptyText = textData.getAttribute(
      'bundly__slot_title_empty',
    );
    const choose = textData.getAttribute('bundly__choose');

    if (gridTitle.innerText !== gridTitleText) {
      gridTitle.innerText = gridTitleText;
      detailsTitle.innerText = detailsTitleText;
      slotTitle.innerText = slotTitleText;

      const bundlyCaption = document.createElement('div');
      bundlyCaption.className = 'bundly-caption';
      bundlyCaption.textContent = `${choose.replace('NUMBER', slotTitleEmpty.length)}`;
      bundlySlots.insertBefore(bundlyCaption, slotHeading.nextSibling);

      slotTitleEmpty.forEach((title) => {
        if (!title.hasAttribute('data-variant-id')) {
          title.querySelector('.bundly__slot_title').innerText =
            slotTitleEmptyText;
        }
      });
    }
    updatePrice();
  }

  function updatePrice() {
    const price = document.querySelector('.bundly__price');
    const originalPrice = document.querySelector(
      '.bundly__bundle_original_price',
    );
    const newPrice = document.querySelector('.bundly__bundle_new_price');
    const originalPriceStr = originalPrice?.innerHTML;
    const discountAmountStr = newPrice?.innerHTML;

    function parsePrice(priceStr) {
      return parseFloat(priceStr.replace(/[€,]/g, '').replace(',', '.'));
    }

    if (originalPriceNumber !== parsePrice(originalPriceStr)) {
      originalPriceNumber = parsePrice(originalPriceStr);
      const discountAmountNumber = parsePrice(discountAmountStr);
      const discountPercentage =
        ((discountAmountNumber - originalPriceNumber) / originalPriceNumber) *
        100;
      price.innerHTML = document.querySelector(
        '#bundly_summery-price',
      ).innerHTML;
      price.querySelector('.price-item--regular').innerHTML =
        newPrice.innerText;
      price.querySelector('.strikethrough-price').innerHTML =
        originalPrice.innerText;
      price.querySelector('.bundly__discount').innerHTML =
        discountPercentage.toFixed().toString().replace('.', ',') + '% Rabatt';
    }
  }

  const targetNode = document.querySelector('.bundly__block');
  if (targetNode) {
    document.addEventListener('bundlyBlocksUpdated', () => {
      updateBundlyData();
    });
    updateBundlyData();

    document.addEventListener('bundlySubmit', async () => {
      await updateCartDrawer();
      window.HensslersFreeGift?.sync();
    });
  }
}

async function updateCartDrawer() {
  try {
    const response = await fetch(
      `${window.location.pathname}?section_id=cart-drawer`,
    );

    if (!response.ok) throw new Error('Failed to fetch cart-drawer section');
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newCartDrawer = doc.querySelector('cart-drawer');

    const oldCartDrawer = document.querySelector('cart-drawer');
    if (oldCartDrawer && newCartDrawer) {
      oldCartDrawer.innerHTML = newCartDrawer.innerHTML;
    }

    const cartDrawer = document.querySelector('cart-drawer');
    cartDrawer.classList.remove('is-empty');
    setTimeout(() => {
      cartDrawer.open();
    }, 1000); // wait till rebux seciton is loaded
  } catch (error) {
    console.error('Error updating cart drawer:', error);
  }
}
